import CssBaseline from '@mui/material/CssBaseline'
import { deDE, enUS, frFR } from '@mui/material/locale'
import { ThemeProvider, createTheme, responsiveFontSizes } from '@mui/material/styles'
import { deDE as dataGridDeDE, enUS as dataGridEnUS, frFR as dataGridFrFR } from '@mui/x-data-grid-premium/locales'
import { deDE as pickersDeDE, enUS as pickersEnUS, frFR as pickersFrFR } from '@mui/x-date-pickers-pro/locales'
import { ReactNode } from 'react'

import { useSettings } from '@core/context/settingsContext'

import { useLanguage } from '~/data/api/hooks/users'
import Direction from '~/layouts/components/Direction'
import { contentThemeId } from '~/theme/themePreference'

import SynopGlobalStyles from './GlobalStyles'
import themeOptions from './ThemeOptions'

interface Props {
  children: ReactNode
}

const ThemeComponent = (props: Props) => {
  const { children } = props
  const { settings } = useSettings()
  const theme = responsiveFontSizes(createTheme(themeOptions(settings, contentThemeId(settings.themeId)), ...useMuiLocales()))

  return (
    <ThemeProvider theme={theme}>
      <Direction direction={settings.direction}>
        <CssBaseline />
        <SynopGlobalStyles />
        {children}
      </Direction>
    </ThemeProvider>
  )
}

export default ThemeComponent

function useMuiLocales() {
  switch (useLanguage()) {
    case 'de':
      return [deDE, dataGridDeDE, pickersDeDE]
    case 'fr':
      return [frFR, dataGridFrFR, pickersFrFR]
    default:
      return [enUS, dataGridEnUS, pickersEnUS]
  }
}
